export function disableSubmitOnEnterKeyForInputs(inputs: HTMLInputElement[]): void {
  inputs.forEach((input) => {
    input.onkeypress = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    };
  });
}
